// extracted by mini-css-extract-plugin
module.exports = {"no-equipment-wrapper":"pdp-no-equipment_no-equipment-wrapper__NNh3E","no-equipment__image":"pdp-no-equipment_no-equipment__image__JYofx"};